<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Contrat types') }}</h4>
        </div>
        <div class="btn-row">
          <button
            type="button"
            class="btn btn-dark mr-2"
            v-if="selected.length >= 2"
            @click="mergeContracts()">
            Unir {{ selected.length }} contrato(s)
            </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="showCreateModal ()">
            + {{ $t('New') }}
            </button>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <creating
        v-if="creating"
        height="100%" />

      <div
        v-if="!creating"
        :class="{'box-loading': loading}">

        <table class="table" v-if="contracts.length">
          <thead>
            <tr>
              <th></th>
              <th class="text-truncate">{{ $t('Name') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in contracts"
              :key="index">
              <td width="10"><input type="checkbox" :value="item._id" v-model="selected"></td>
              <td class="text-truncate"><a href="javascript:void(0)" @click="showEditModal (item)">{{ item.name }}</a></td>
            </tr>
          </tbody>
        </table>

        <no-results 
          v-if="!contracts.length">
          {{ $t('There are no items') }}
        </no-results>

      </div>
    </div>

    <div
      v-if="modal_select"
      class="vflex-row-0">
      <contract-form 
        :initContract="modal_select" 
        @hideModal="hideModal()" 
        @deleted="loadData(); hideModal()" 
        @saved="loadData(); hideModal()" 
        ></contract-form>
    </div>

  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import ContractForm from './ContractForm'

export default {
  name: 'Contract',
  components: {
    ContractForm,
    InputKeyword
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      selected: []
    }
  },
  computed: {
    contracts () {
      return this.$store.getters.getContracts
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    loadData
    */
    loadData () {
      this.loading = true

      let params = {
        sort: 'name',
        limit: 1000
      }

      this.$store
      .dispatch('selectContracts', params)
      .then((result) => {
        this.loading = this.creating = false
      })
    },
    /*
    mergeContracts
    */
    mergeContracts () {
      const mergeAction = () => {
        this.loading = true

        this.$store
        .dispatch('mergeContracts', {contracts: this.selected})
        .then((result) => {
          this.selected = []
          this.loadData(1)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: mergeAction,
        title: 'Deseja realmente unir esses registros?'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Contract/Contract.vue